/**
 * Модуль для работы с боевыми статусами и эффектами
 */

export const STATUS_EFFECTS = {
    swap_lock: {
      type: "swap_lock",
      icon: "⛓️",
      label: "Блок смены позиции",
      shortLabel: "Блок",
      description: "Нельзя менять позицию до завершения эффекта.",
    },
    speed_boost: {
      type: "speed_boost",
      icon: "⚡",
      label: "Прирост инициативы",
      shortLabel: "+SPD",
      description: "Существо действует быстрее благодаря God Context Switch.",
    },
    corrupted: {
      type: "corrupted",
      icon: "🌀",
      label: "Искажение типов",
      shortLabel: "Искажение",
      description: "Типы атак принудительно сменены на Glitch/Chaos.",
    },
    deadlock: {
      type: "deadlock",
      icon: "☠️",
      label: "Deadlock",
      shortLabel: "Deadlock",
      description: "Наказание за бездействие. Сильное снижение HP.",
    },
    swap_shift: {
      type: "swap_shift",
      icon: "🔄",
      label: "Перестановка позиций",
      shortLabel: "Swap",
      description: "Недавнее перемешивание позиций Race God to Void.",
    },
    floating_guard: {
      type: "floating_guard",
      icon: "🛡️",
      label: "NaN-барьер",
      shortLabel: "NaN",
      description: "Floating God Cloud отклонил удар — урон обнулён.",
    },
    fog_aura: {
      type: "fog_aura",
      icon: "🌫️",
      label: "Indeterminate Fog",
      shortLabel: "Fog",
      description: "Аура снижает точность атакующих существ.",
    },
    nebula_evade: {
      type: "nebula_evade",
      icon: "✨",
      label: "Эфирная уклончивость",
      shortLabel: "+EV",
      description: "Уклонение усилено Nebula Apotheosis.",
    },
    nebula_no_crit: {
      type: "nebula_no_crit",
      icon: "🚫",
      label: "Криты заблокированы",
      shortLabel: "NoCrit",
      description: "Критические удары по существу запрещены Nebula Apotheosis.",
    },
    undead_god_bit_status: {
      type: "undead_god_bit_status",
      icon: "🧟",
      label: "Undead протокол",
      shortLabel: "Undead",
      description:
        "Существо воскресло с частичным HP и временной неуязвимостью.",
    },
    resurrect_god_flag_status: {
      type: "resurrect_god_flag_status",
      icon: "⚑",
      label: "Resurrect Flag",
      shortLabel: "Resurrect",
      description:
        "Повторное воскрешение: добавляет тип Undead и частично восстанавливает HP.",
    },
    bit_plague_prime_debuff: {
      type: "bit_plague_prime_debuff",
      icon: "☣️",
      label: "Bit Plague",
      shortLabel: "Plague",
      description: "Периодический урон и штраф точности от Bit Plague Prime.",
    },
    bit_plague_prime_buff: {
      type: "bit_plague_prime_buff",
      icon: "💉",
      label: "Plague Boon",
      shortLabel: "+HoT",
      description: "Лечение и бонус к уклонению от Bit Plague Prime.",
    },
    memory_god_grave_shadow: {
      type: "memory_god_grave_shadow",
      icon: "🪦",
      label: "Memory Grave",
      shortLabel: "Grave",
      description: "Защитный спектр памяти: блокирует часть урона по союзнику.",
    },
    gateway_god_flood_status: {
      type: "gateway_god_flood_status",
      icon: "🔀",
      label: "Gateway Flood",
      shortLabel: "Redirect",
      description: "Атаки будут перенаправлены на случайные цели.",
    },
    rate_god_limit_debuff: {
      type: "rate_god_limit_debuff",
      icon: "📉",
      label: "Rate Limit",
      shortLabel: "Limit",
      description: "Действия ограничены: пропуски ходов и штраф скорости.",
    },
    ddos_cathedral_dot: {
      type: "ddos_cathedral_dot",
      icon: "🌩️",
      label: "DDoS Шторм",
      shortLabel: "DoT",
      description: "Периодический урон от DDoS Cathedral.",
    },
    ddos_cathedral_hot: {
      type: "ddos_cathedral_hot",
      icon: "✨",
      label: "DDoS Реген",
      shortLabel: "HoT",
      description: "Постепенное лечение от DDoS Cathedral.",
    },
    hotplug_god_horror_applied: {
      type: "hotplug_god_horror_applied",
      icon: "🔌",
      label: "Hotplug Horror",
      shortLabel: "Hotplug",
      description: "USBghost наносит стартовый импульс: защита цели снижена.",
    },
    mirror_universe_buff: {
      type: "mirror_universe_buff",
      icon: "🪞",
      label: "Mirror Blessing",
      shortLabel: "Mirror+",
      description: "Баффы скопированы из зеркальной вселенной.",
    },
    mirror_universe_debuff: {
      type: "mirror_universe_debuff",
      icon: "🪞",
      label: "Mirror Curse",
      shortLabel: "Mirror−",
      description: "Дебафф отражён обратно на противника.",
    },
    underworld_stack_speed: {
      type: "underworld_stack_speed",
      icon: "💨",
      label: "Underworld Rush",
      shortLabel: "+SPD",
      description: "Скорость повышена ритуалом Underworld Stack.",
    },
    underworld_stack_vulnerable: {
      type: "underworld_stack_vulnerable",
      icon: "🎯",
      label: "Underworld Vulnerability",
      shortLabel: "Vuln",
      description: "Получаемый урон увеличен после Underworld Stack.",
    },
    fragment_god_armor_bonus: {
      type: "fragment_god_armor_bonus",
      icon: "🧱",
      label: "Fragment Armor",
      shortLabel: "+DEF",
      description: "Защитные сегменты Fragment God Armor.",
    },
    memory_dam_block_regen: {
      type: "memory_dam_block_regen",
      icon: "🚫",
      label: "Regen Block",
      shortLabel: "NoRegen",
      description: "Восстановление HP блокировано Memory Dam.",
    },
    sealed_orbit_reflect: {
      type: "sealed_orbit_reflect",
      icon: "🛰️",
      label: "Sealed Orbit",
      shortLabel: "Reflect",
      description: "Союзники отражают дебаффы обратно врагам.",
    },
    sealed_orbit_block_hidden: {
      type: "sealed_orbit_block_hidden",
      icon: "🚷",
      label: "Hidden Block",
      shortLabel: "Block",
      description: "Скрытые эффекты врагов заблокированы Sealed Orbit.",
    },
    time_crown_haste: {
      type: "time_crown_haste",
      icon: "⏱️",
      label: "Time Crown",
      shortLabel: "+Turns",
      description: "Дополнительные ходы и инициатива от Time Crown.",
    },
    time_crown_skip: {
      type: "time_crown_skip",
      icon: "⏭️",
      label: "Time Skip",
      shortLabel: "Skip",
      description: "Противник пропустит следующий ход.",
    },
    shock_god_propagation: {
      type: "shock_god_propagation",
      icon: "⚡",
      label: "Shock Propagation",
      shortLabel: "Spread",
      description: "Следующая атака распространит урон на соседей.",
    },
    backpressure_choke: {
      type: "backpressure_choke",
      icon: "🌊",
      label: "Backpressure",
      shortLabel: "Choke",
      description: "Нарастает волна урона, готовая к выбросу.",
    },
    deadlock_apex_haste: {
      type: "deadlock_apex_haste",
      icon: "🚀",
      label: "Deadlock Surge",
      shortLabel: "+SPD",
      description: "Инициатива увеличена благодаря Deadlock Apex.",
    },
    deadlock_apex_freeze: {
      type: "deadlock_apex_freeze",
      icon: "🧊",
      label: "Deadlock Freeze",
      shortLabel: "Freeze",
      description: "Противник застывает и пропустит ход.",
    },
    null_ref_phase: {
      type: "null_ref_phase",
      icon: "🪐",
      label: "Null Phase",
      shortLabel: "Phase",
      description: "NullRef уходит в фазу и избегает урона.",
    },
    null_ref_debuff: {
      type: "null_ref_debuff",
      icon: "🕳️",
      label: "Null Collapse",
      shortLabel: "Collapse",
      description: "Снижение характеристик после Null Reference.",
    },
    fork_eruption_buff: {
      type: "fork_eruption_buff",
      icon: "🍴",
      label: "Fork Overclock",
      shortLabel: "Clone+",
      description: "Союзники получают бонусные действия от Fork Eruption.",
    },
    fork_eruption_debuff: {
      type: "fork_eruption_debuff",
      icon: "🧨",
      label: "Fork Lag",
      shortLabel: "Slow",
      description: "Враги теряют инициативу после Fork Eruption.",
    },
    grave_convergence_debuff: {
      type: "grave_convergence_debuff",
      icon: "🪦",
      label: "Grave Convergence",
      shortLabel: "Grave−",
      description: "Периодический урон и падение скорости.",
    },
    identity_maelstrom_buff: {
      type: "identity_maelstrom_buff",
      icon: "🎭",
      label: "Identity Surge",
      shortLabel: "ID+",
      description:
        "Союзники получают уклонение и скорость от Identity Maelstrom.",
    },
    identity_maelstrom_debuff: {
      type: "identity_maelstrom_debuff",
      icon: "🎭",
      label: "Identity Spiral",
      shortLabel: "ID−",
      description:
        "Враги теряют точность и инициативу из-за Identity Maelstrom.",
    },
    gpu_thermal_dot: {
      type: "gpu_thermal_dot",
      icon: "🔥",
      label: "Thermal Overload",
      shortLabel: "Overheat",
      description: "Периодический термальный урон от GPUlare.",
    },
    gpu_render_phoenix: {
      type: "gpu_render_phoenix",
      icon: "🪶",
      label: "Render Phoenix",
      shortLabel: "Phoenix",
      description: "Возрождение с щитом от Render Phoenix.",
    },
    saltstorm_ally_buff: {
      type: "saltstorm_ally_buff",
      icon: "🧂",
      label: "Saltstorm Boon",
      shortLabel: "Salt+",
      description: "Криты и иммунитет к контролю от Saltstorm.",
    },
    saltstorm_enemy_debuff: {
      type: "saltstorm_enemy_debuff",
      icon: "🧂",
      label: "Saltstorm Wound",
      shortLabel: "Salt−",
      description: "Регенерация врагов заблокирована Saltstorm.",
    },
    void_absolution_immunity: {
      type: "void_absolution_immunity",
      icon: "🛡️",
      label: "Void Absolution",
      shortLabel: "Immunity",
      description: "Союзники защищены от контроля.",
    },
    void_absolution_silence: {
      type: "void_absolution_silence",
      icon: "🔇",
      label: "Void Silence",
      shortLabel: "Silence",
      description: "Названные атаки заблокированы Void Absolution.",
    },
    exit_event_speed: {
      type: "exit_event_speed",
      icon: "🚪",
      label: "Exit Velocity",
      shortLabel: "+SPD",
      description: "Скорость увеличена после Exit Event.",
    },
    rom_eternity_readonly: {
      type: "rom_eternity_readonly",
      icon: "💾",
      label: "ROM Eternity",
      shortLabel: "ROM",
      description: "Статусы Read Only: нельзя снять или изменить.",
    },
    heap_cathedral_dot: {
      type: "heap_cathedral_dot",
      icon: "♨️",
      label: "Heap Burn",
      shortLabel: "Heap",
      description: "Периодический урон от Heap Cathedral.",
    },
    chaos_buff_attack: {
      type: "chaos_buff_attack",
      icon: "⚔️",
      label: "Chaos Boost ATK",
      shortLabel: "+ATK",
      description: "Атака увеличена хаотическим благословением.",
    },
    chaos_buff_speed: {
      type: "chaos_buff_speed",
      icon: "⚡",
      label: "Chaos Boost SPD",
      shortLabel: "+SPD",
      description: "Скорость увеличена хаотическим благословением.",
    },
    chaos_buff_crit: {
      type: "chaos_buff_crit",
      icon: "✴️",
      label: "Chaos Boost Crit",
      shortLabel: "+Crit",
      description: "Шанс крита повышен хаотическим благословением.",
    },
    chaos_buff_reflect: {
      type: "chaos_buff_reflect",
      icon: "🔁",
      label: "Chaos Reflect",
      shortLabel: "Reflect",
      description: "Отражает часть входящего урона.",
    },
    chaos_debuff_attack: {
      type: "chaos_debuff_attack",
      icon: "⚔️",
      label: "Chaos Drain ATK",
      shortLabel: "−ATK",
      description: "Атака снижена хаотическим проклятьем.",
    },
    chaos_debuff_speed: {
      type: "chaos_debuff_speed",
      icon: "🐢",
      label: "Chaos Drain SPD",
      shortLabel: "−SPD",
      description: "Скорость снижена хаотическим проклятьем.",
    },
    chaos_debuff_accuracy: {
      type: "chaos_debuff_accuracy",
      icon: "🎯",
      label: "Chaos Drain ACC",
      shortLabel: "−ACC",
      description: "Точность снижена хаотическим проклятьем.",
    },
    chaos_debuff_dot: {
      type: "chaos_debuff_dot",
      icon: "☠️",
      label: "Chaos Decay",
      shortLabel: "DoT",
      description: "Периодический урон хаосом.",
    },
    propagation: {
      type: "propagation",
      icon: "⚡",
      label: "Crash Propagation",
      shortLabel: "Prop",
      description: "Повреждения распространятся на другие цели.",
    },
  };
  function Zn(e) {
    return {
      type: e.type,
      icon: e.icon,
      label: e.label,
      shortLabel: e.shortLabel,
      description: e.description,
      expiresAt: e.expiresAt ?? null,
    };
  }
  function Yt(e) {
    return e
      ? String(e)
          .replace(/[_\-]+/g, " ")
          .replace(/\s+/g, " ")
          .trim()
          .split(" ")
          .filter(Boolean)
          .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
          .join(" ")
      : "";
  }
  function es(e) {
    if (!e) return "";
    const t = e.trim();
    if (t.length <= 6) return t;
    const n = t.split(/\s+/).filter(Boolean);
    return n.length === 1
      ? t.slice(0, 6)
      : n.map((s) => s.charAt(0).toUpperCase()).join("");
  }
  function R(e, t = {}, n = null) {
    return e
      ? { ...e, ...t, expiresAt: t.expiresAt ?? n ?? e.expiresAt ?? null }
      : null;
  }
  function ts(e, t = null) {
    var p, r, l, f, v;
    const n = (p = e == null ? void 0 : e.data) == null ? void 0 : p.category,
      s =
        ((r = e == null ? void 0 : e.data) == null ? void 0 : r.label) ||
        Yt(e == null ? void 0 : e.type),
      o =
        ((l = e == null ? void 0 : e.data) == null ? void 0 : l.shortLabel) ||
        es(s),
      a =
        ((f = e == null ? void 0 : e.data) == null ? void 0 : f.description) ||
        (n === "buff"
          ? `Положительный эффект: ${s}`
          : n === "debuff"
            ? `Отрицательный эффект: ${s}`
            : `Особый эффект: ${s}`),
      u =
        ((v = e == null ? void 0 : e.data) == null ? void 0 : v.icon) ||
        (n === "buff" ? "🔹" : n === "debuff" ? "🔻" : "◆");
    return {
      type: (e == null ? void 0 : e.type) || "status",
      icon: u,
      label: s,
      shortLabel: o,
      description: a,
      expiresAt: t,
    };
  }
  function K(e, t = 0) {
    if (e == null || !Number.isFinite(Number(e))) return null;
    const n = Math.pow(10, Math.max(0, t)),
      s = Math.round(Number(e) * 100 * n) / n;
    return `${s}${Number.isFinite(s) ? "%" : ""}`;
  }
  function ee(e, t, n) {
    const s = String(t),
      a = (e.get(s) || []).filter((u) => u.type !== n.type);
    (a.push(n), e.set(s, a));
  }
  function ns(e, t, n, s) {
    var f;
    const o = String(n ?? "");
    if (!o) return;
    const a = t.get(o);
    if (!a) return;
    const u =
        ((f = a == null ? void 0 : a.state) == null
          ? void 0
          : f.statusEffects) || [],
      p = [];
    for (const v of u) {
      const A = Kt(v, s);
      A && p.push(A);
    }
    const r = e.get(o) || [];
    if (!p.length) {
      if (r.length) {
        const v = r.filter((A) => u.some((P) => P.type === A.type) === !1);
        v.length ? e.set(o, v) : e.delete(o);
      } else e.delete(o);
      return;
    }
    const l = r.filter((v) => !p.some((A) => A.type === v.type));
    (l.push(...p), e.set(o, l));
  }
  function ss(e, t) {
    for (const [n, s] of e.entries()) {
      const o = s.filter((a) => a.expiresAt == null || t < a.expiresAt);
      o.length ? e.set(n, o) : e.delete(n);
    }
  }
  function os(e) {
    const t = {};
    for (const [n, s] of e.entries()) t[n] = s.map(Zn);
    return t;
  }
  function Kt(e = {}, t = 0) {
    var a,
      u,
      p,
      r,
      l,
      f,
      v,
      A,
      P,
      j,
      L,
      O,
      V,
      ge,
      Z,
      se,
      be,
      xe,
      Xe,
      re,
      ke,
      F,
      Q,
      le,
      ve,
      ye,
      Ae,
      fn,
      hn;
    if (!e || !e.type) return null;
    const n = String(e.type),
      s = typeof e.expiresAtRound == "number" ? e.expiresAtRound : null;
    switch (n) {
      case "hex_god_corruption_mark":
        return R(STATUS_EFFECTS.corrupted, { expiresAt: s });
      case "infinity_thread_swap_lock":
        return R(STATUS_EFFECTS.swap_lock, {
          expiresAt:
            s ?? t + (((a = e.data) == null ? void 0 : a.duration) ?? 0),
        });
      case "nebula_apotheosis_buff":
        return R(STATUS_EFFECTS.nebula_evade, { expiresAt: s });
      case "nebula_apotheosis_debuff":
        return R(STATUS_EFFECTS.nebula_no_crit, { expiresAt: s });
      case "undead_god_bit_status":
      case "resurrect_god_flag_status":
        return R(B[n], { expiresAt: s });
      case "bit_plague_prime_debuff": {
        const g = STATUS_EFFECTS.bit_plague_prime_debuff,
          _ = Number(((u = e.data) == null ? void 0 : u.dot) ?? 0),
          T = Number(((p = e.data) == null ? void 0 : p.accuracyPenalty) ?? 0),
          U = [];
        return (
          _ > 0 && U.push(`DoT ${_} HP/ход`),
          T > 0 && U.push(`−${Math.round(T * 100)}% ACC`),
          R(g, {
            shortLabel: _ > 0 ? `-${_}HP` : g.shortLabel,
            description: U.length
              ? `${g.description}. ${U.join(", ")}`
              : g.description,
            expiresAt: s,
          })
        );
      }
      case "bit_plague_prime_buff": {
        const g = STATUS_EFFECTS.bit_plague_prime_buff,
          _ = Number(((r = e.data) == null ? void 0 : r.hot) ?? 0),
          T = Number(((l = e.data) == null ? void 0 : l.evadeBonus) ?? 0),
          U = [];
        return (
          _ > 0 && U.push(`HoT ${_} HP/ход`),
          T > 0 && U.push(`+${Math.round(T * 100)}% EV`),
          R(g, {
            shortLabel: _ > 0 ? `+${_}HP` : g.shortLabel,
            description: U.length
              ? `${g.description}. ${U.join(", ")}`
              : g.description,
            expiresAt: s,
          })
        );
      }
      case "memory_god_grave_shadow": {
        const g = STATUS_EFFECTS.memory_god_grave_shadow,
          _ = Number(((f = e.data) == null ? void 0 : f.duration) ?? 0);
        return R(g, {
          description:
            _ > 0 ? `${g.description} (осталось ${_} ходов)` : g.description,
          expiresAt: s,
        });
      }
      case "gateway_god_flood_status": {
        const g = STATUS_EFFECTS.gateway_god_flood_status,
          _ = Number(
            ((v = e.data) == null ? void 0 : v.reroutesRemaining) ?? 0,
          );
        return R(g, {
          description:
            _ > 0 ? `${g.description} (${_} перенаправлений)` : g.description,
          shortLabel: _ > 0 ? `⇄${_}` : g.shortLabel,
          expiresAt: s,
        });
      }
      case "rate_god_limit_debuff": {
        const g = STATUS_EFFECTS.rate_god_limit_debuff,
          _ = Number(((A = e.data) == null ? void 0 : A.skipsRemaining) ?? 0),
          T = Number(((P = e.data) == null ? void 0 : P.speedPenalty) ?? 0),
          U = [];
        return (
          _ > 0 && U.push(`пропусков: ${_}`),
          T > 0 && U.push(`−${T} SPD`),
          R(g, {
            shortLabel: T > 0 ? `−${T}SPD` : g.shortLabel,
            description: U.length
              ? `${g.description}. ${U.join(", ")}`
              : g.description,
            expiresAt: s,
          })
        );
      }
      case "ddos_cathedral_dot": {
        const g = STATUS_EFFECTS.ddos_cathedral_dot,
          _ = Number(((j = e.data) == null ? void 0 : j.dot) ?? 0);
        return R(g, {
          shortLabel: _ > 0 ? `-${_}HP` : g.shortLabel,
          description: _ > 0 ? `${g.description} (${_} HP/ход)` : g.description,
          expiresAt: s,
        });
      }
      case "ddos_cathedral_hot": {
        const g = STATUS_EFFECTS.ddos_cathedral_hot,
          _ = Number(((L = e.data) == null ? void 0 : L.hot) ?? 0);
        return R(g, {
          shortLabel: _ > 0 ? `+${_}HP` : g.shortLabel,
          description: _ > 0 ? `${g.description} (${_} HP/ход)` : g.description,
          expiresAt: s,
        });
      }
      case "underworld_stack_speed": {
        const g = STATUS_EFFECTS.underworld_stack_speed,
          _ = Number(((O = e.data) == null ? void 0 : O.speedBonus) ?? 0);
        return R(g, {
          shortLabel: _ > 0 ? `+${_}SPD` : g.shortLabel,
          description:
            _ > 0 ? `${g.description} (+${_} скорости)` : g.description,
          expiresAt: s,
        });
      }
      case "underworld_stack_vulnerable": {
        const g = STATUS_EFFECTS.underworld_stack_vulnerable,
          _ = Number(((V = e.data) == null ? void 0 : V.defensePenalty) ?? 0);
        return R(g, {
          shortLabel: _ > 0 ? `+${_}%DMG` : g.shortLabel,
          description:
            _ > 0 ? `${g.description} (+${_}% входящего урона)` : g.description,
          expiresAt: s,
        });
      }
      case "fragment_god_armor_bonus": {
        const g = STATUS_EFFECTS.fragment_god_armor_bonus,
          _ = Number(((ge = e.data) == null ? void 0 : ge.defenseBonus) ?? 0),
          T = Number(((Z = e.data) == null ? void 0 : Z.fragmentStacks) ?? 0),
          U = [];
        return (
          _ > 0 && U.push(`+${_} DEF`),
          T > 0 && U.push(`${T} фрагм.`),
          R(g, {
            shortLabel: _ > 0 ? `+${_}DEF` : g.shortLabel,
            description: U.length
              ? `${g.description}: ${U.join(", ")}`
              : g.description,
            expiresAt: s,
          })
        );
      }
      case "grave_convergence_debuff": {
        const g = STATUS_EFFECTS.grave_convergence_debuff,
          _ = Number(((se = e.data) == null ? void 0 : se.dot) ?? 0),
          T = Number(((be = e.data) == null ? void 0 : be.speedPenalty) ?? 0),
          U = [];
        return (
          _ > 0 && U.push(`DoT ${_} HP/ход`),
          T > 0 && U.push(`−${T} SPD`),
          R(g, {
            shortLabel: _ > 0 ? `-${_}HP` : g.shortLabel,
            description: U.length
              ? `${g.description}. ${U.join(", ")}`
              : g.description,
            expiresAt: s,
          })
        );
      }
      case "gpu_thermal_dot": {
        const g = STATUS_EFFECTS.gpu_thermal_dot,
          _ = Number(((xe = e.data) == null ? void 0 : xe.dot) ?? 0);
        return R(g, {
          shortLabel: _ > 0 ? `-${_}HP` : g.shortLabel,
          description: _ > 0 ? `${g.description} (${_} HP/ход)` : g.description,
          expiresAt: s,
        });
      }
      case "gpu_render_phoenix": {
        const g = STATUS_EFFECTS.gpu_render_phoenix,
          _ = Number(((Xe = e.data) == null ? void 0 : Xe.shieldAmount) ?? 0);
        return R(g, {
          shortLabel: _ > 0 ? `+${_}SH` : g.shortLabel,
          description: _ > 0 ? `${g.description} (щит ${_})` : g.description,
          expiresAt: s,
        });
      }
      case "saltstorm_ally_buff": {
        const g = STATUS_EFFECTS.saltstorm_ally_buff,
          _ = Number(((re = e.data) == null ? void 0 : re.critBonus) ?? 0),
          T = _ > 0 ? K(_, 0) : null,
          U = [];
        return (
          T && U.push(`Крит шанс +${T}`),
          (ke = e.data) != null &&
            ke.controlResist &&
            U.push("Иммунитет к контролю"),
          R(g, {
            shortLabel: T ? `+${T}` : g.shortLabel,
            description: U.length
              ? `${g.description}. ${U.join(", ")}`
              : g.description,
            expiresAt: s,
          })
        );
      }
      case "saltstorm_enemy_debuff":
        return R(STATUS_EFFECTS.saltstorm_enemy_debuff, { expiresAt: s });
      case "chaos_buff_attack": {
        const g = STATUS_EFFECTS.chaos_buff_attack,
          _ = Number(((F = e.data) == null ? void 0 : F.attackBonus) ?? 0),
          T = _ > 0 ? K(_, 0) : null;
        return R(g, {
          shortLabel: T ? `+${T}` : g.shortLabel,
          description: T ? `${g.description} (${T})` : g.description,
          expiresAt: s,
        });
      }
      case "chaos_buff_speed": {
        const g = STATUS_EFFECTS.chaos_buff_speed,
          _ = Number(((Q = e.data) == null ? void 0 : Q.speedBonus) ?? 0),
          T = _ > 0 ? K(_, 0) : null;
        return R(g, {
          shortLabel: T ? `+${T}` : g.shortLabel,
          description: T ? `${g.description} (${T})` : g.description,
          expiresAt: s,
        });
      }
      case "chaos_buff_crit": {
        const g = STATUS_EFFECTS.chaos_buff_crit,
          _ = Number(((le = e.data) == null ? void 0 : le.critBonus) ?? 0),
          T = _ > 0 ? K(_, 0) : null;
        return R(g, {
          shortLabel: T ? `+${T}` : g.shortLabel,
          description: T ? `${g.description} (${T})` : g.description,
          expiresAt: s,
        });
      }
      case "chaos_buff_reflect": {
        const g = STATUS_EFFECTS.chaos_buff_reflect,
          _ = Number(((ve = e.data) == null ? void 0 : ve.reflectPercent) ?? 0),
          T = _ > 0 ? K(_, 0) : null;
        return R(g, {
          shortLabel: T || g.shortLabel,
          description: T ? `${g.description} (${T})` : g.description,
          expiresAt: s,
        });
      }
      case "chaos_debuff_attack": {
        const g = STATUS_EFFECTS.chaos_debuff_attack,
          _ = Number(((ye = e.data) == null ? void 0 : ye.attackPenalty) ?? 0),
          T = _ > 0 ? K(_, 0) : null;
        return R(g, {
          shortLabel: T ? `-${T}` : g.shortLabel,
          description: T ? `${g.description} (${T})` : g.description,
          expiresAt: s,
        });
      }
      case "chaos_debuff_speed": {
        const g = STATUS_EFFECTS.chaos_debuff_speed,
          _ = Number(((Ae = e.data) == null ? void 0 : Ae.speedPenalty) ?? 0),
          T = _ > 0 ? K(_, 0) : null;
        return R(g, {
          shortLabel: T ? `-${T}` : g.shortLabel,
          description: T ? `${g.description} (${T})` : g.description,
          expiresAt: s,
        });
      }
      case "chaos_debuff_accuracy": {
        const g = STATUS_EFFECTS.chaos_debuff_accuracy,
          _ = Number(
            ((fn = e.data) == null ? void 0 : fn.accuracyPenalty) ?? 0,
          ),
          T = _ > 0 ? K(_, 0) : null;
        return R(g, {
          shortLabel: T ? `-${T}` : g.shortLabel,
          description: T ? `${g.description} (${T})` : g.description,
          expiresAt: s,
        });
      }
      case "chaos_debuff_dot": {
        const g = STATUS_EFFECTS.chaos_debuff_dot,
          _ = Number(((hn = e.data) == null ? void 0 : hn.dot) ?? 0);
        return R(g, {
          shortLabel: _ > 0 ? `-${_}HP` : g.shortLabel,
          description: _ > 0 ? `${g.description} (${_} HP/ход)` : g.description,
          expiresAt: s,
        });
      }
      case "memory_dam_block_regen":
        return R(STATUS_EFFECTS.memory_dam_block_regen, { expiresAt: s });
      case "sealed_orbit_reflect":
      case "sealed_orbit_block_hidden":
        return R(B[n], { expiresAt: s });
      case "time_crown_haste":
      case "time_crown_skip":
      case "shock_god_propagation":
      case "backpressure_choke":
      case "deadlock_apex_haste":
      case "deadlock_apex_freeze":
      case "null_ref_phase":
      case "null_ref_debuff":
      case "fork_eruption_buff":
      case "fork_eruption_debuff":
      case "identity_maelstrom_buff":
      case "identity_maelstrom_debuff":
      case "void_absolution_immunity":
      case "void_absolution_silence":
      case "exit_event_speed":
      case "rom_eternity_readonly":
      case "heap_cathedral_dot":
      case "propagation":
        return R(B[n], { expiresAt: s });
    }
    const o = STATUS_EFFECTS[n];
    return o ? R(o, {}, s) : ts(e, s);
  }
  function is(e, t, n = 0) {
    ((t == null ? void 0 : t.combatants) || []).forEach((o) => {
      var u;
      (
        ((u = o == null ? void 0 : o.state) == null
          ? void 0
          : u.statusEffects) || []
      ).forEach((p) => {
        const r = Kt(p, n);
        if (r) {
          const l =
            o.id ??
            o.panelId ??
            o.slotId ??
            o.sourceId ??
            o.combatantId ??
            o.id;
          ee(e, l, r);
        }
      });
    });
  }
  function as(e, t, n, s = 0) {
    var l, f;
    if (!e) return;
    const o = e.round ?? 0,
      a = Number.isFinite(s) ? s : o,
      u = n.get(String(e.ownerId ?? "")) || null,
      p = (v) => {
        v != null && ns(t, n, v, a);
      },
      r = (v) => {
        v &&
          (Array.isArray(v)
            ? v.forEach((A) => {
                A != null &&
                  (typeof A == "object"
                    ? (A.id != null && p(A.id),
                      A.targetId != null && p(A.targetId),
                      A.ownerId != null && p(A.ownerId))
                    : p(A));
              })
            : typeof v == "object"
              ? (v.id != null && p(v.id),
                v.targetId != null && p(v.targetId),
                v.ownerId != null && p(v.ownerId))
              : p(v));
      };
    switch (e.event) {
      case "effect:floating_god_cloud": {
        e.defenderId != null &&
          ee(t, e.defenderId, { ...STATUS_EFFECTS.floating_guard, expiresAt: o + 1 });
        break;
      }
      case "effect:indeterminate_god_fog": {
        e.ownerId != null &&
          ee(t, e.ownerId, {
            ...STATUS_EFFECTS.fog_aura,
            description: `Снижение точности ×${(e.multiplier ?? 1).toFixed(2)}`,
            expiresAt: o + 1,
          });
        break;
      }
      case "effect:nebula_apotheosis_cast": {
        const v = e.duration ?? e.durationRounds ?? 3,
          A = o + v;
        ((e.alliesAffected || []).forEach((P) => {
          ee(t, P, { ...STATUS_EFFECTS.nebula_evade, expiresAt: A });
        }),
          (e.enemiesAffected || []).forEach((P) => {
            ee(t, P, { ...STATUS_EFFECTS.nebula_no_crit, expiresAt: A });
          }));
        break;
      }
      case "effect:nebula_apotheosis_evade_bonus": {
        if (e.defenderId != null) {
          const v = e.bonus != null ? Math.round(e.bonus * 100) : null;
          ee(t, e.defenderId, {
            ...STATUS_EFFECTS.nebula_evade,
            label:
              v != null ? `Эфирная уклончивость +${v}%` : STATUS_EFFECTS.nebula_evade.label,
            shortLabel: v != null ? `+${v}% EV` : STATUS_EFFECTS.nebula_evade.shortLabel,
            expiresAt: o + 1,
          });
        }
        break;
      }
      case "effect:nebula_apotheosis_block_crit": {
        e.defenderId != null &&
          ee(t, e.defenderId, { ...STATUS_EFFECTS.nebula_no_crit, expiresAt: o + 1 });
        break;
      }
      case "effect:god_context_switch": {
        const v = e.debuffRounds ?? 0,
          A = o + v;
        if (
          ((e.enemiesAffected || []).forEach((P) => {
            ee(t, P, { ...STATUS_EFFECTS.swap_lock, expiresAt: A });
          }),
          u)
        ) {
          const P = u.team;
          Array.from(n.values())
            .filter((L) => L.team === P)
            .forEach((L) => {
              const O = e.initiativeBonus ?? 0;
              ee(t, L.id, {
                ...STATUS_EFFECTS.speed_boost,
                label: `Прирост скорости +${O}`,
                shortLabel: `+${O} SPD`,
                expiresAt: null,
              });
            });
        }
        break;
      }
      case "effect:hex_god_corruption_apply": {
        const v = (e.forcedTypes || []).join("/");
        ee(t, e.attackerId, {
          ...STATUS_EFFECTS.corrupted,
          description: v ? `Типы атак: ${v}` : STATUS_EFFECTS.corrupted.description,
          expiresAt: null,
        });
        break;
      }
      case "effect:deadlock_god_embrace": {
        (ee(t, e.ownerId, { ...STATUS_EFFECTS.deadlock, expiresAt: o + 1 }),
          e.targetId != null &&
            ee(t, e.targetId, { ...STATUS_EFFECTS.deadlock, expiresAt: o + 1 }));
        break;
      }
      case "effect:race_god_to_void_swap": {
        (e.swaps || []).forEach((v) => {
          ee(t, v.id, { ...STATUS_EFFECTS.swap_shift, expiresAt: o + 1 });
        });
        break;
      }
      case "effect:gateway_god_flood_cast": {
        for (const v of n.keys()) p(v);
        break;
      }
    }
    (e.ownerId != null && p(e.ownerId),
      e.targetId != null && p(e.targetId),
      e.attackerId != null && p(e.attackerId),
      e.defenderId != null && p(e.defenderId),
      e.actorId != null && p(e.actorId),
      e.summonId != null && p(e.summonId),
      r(e.allies),
      r(e.enemies),
      r(e.targets),
      e.alliesAffected && r(e.alliesAffected),
      e.enemiesAffected && r(e.enemiesAffected),
      e.revived && r(e.revived),
      e.taken && r(e.taken),
      (l = e.applied) != null && l.allies && r(e.applied.allies),
      (f = e.applied) != null && f.enemies && r(e.applied.enemies),
      e.affected && r(e.affected));
  }
  function te(e, t) {
    if (t == null) return "";
    const n = e.get(String(t));
    return n != null && n.name ? n.name : `#${t}`;
  }
// Экспортируемые функции
export function normalizeStatusEffect(e) {
  return Zn(e);
}

export function createStatusEffect(e, t = {}, n = null) {
  return R(e, t, n);
}

export function parseStatusEffect(e = {}, t = 0) {
  return Kt(e, t);
}

export function addStatusEffect(e, t, n) {
  return ee(e, t, n);
}

export function syncStatusEffects(e, t, n, s) {
  return ns(e, t, n, s);
}

export function cleanupExpiredStatusEffects(e, t) {
  return ss(e, t);
}

export function serializeStatusEffects(e) {
  return os(e);
}

export function processBattleStatusEffects(e, t, n = 0) {
  return is(e, t, n);
}

export function processEventStatusEffects(e, t, n, s = 0) {
  return as(e, t, n, s);
}

export function getCombatantName(e, t) {
  return te(e, t);
}

// Экспорт вспомогательных функций форматирования
export function formatStatusName(e) {
  return Yt(e);
}

export function formatPercent(e, t = 0) {
  return K(e, t);
}

function formatShortLabel(e) {
  return es(e);
}

// Экспорт константы для обратной совместимости
export const B = STATUS_EFFECTS;

// Экспорт для обратной совместимости (старые имена функций)
// Yt и K уже объявлены внутри модуля, используем их напрямую
export { Yt, K };
